export default "__VITE_ASSET__BxJ6k0yd__"